import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importar traducciones - Español
import esCommon from './locales/es/common.json';
import esGuestPortal from './locales/es/guestPortal.json';

// Importar traducciones - Català
import caCommon from './locales/ca/common.json';
import caGuestPortal from './locales/ca/guestPortal.json';

// Importar traducciones - English
import enCommon from './locales/en/common.json';
import enGuestPortal from './locales/en/guestPortal.json';

// Importar traducciones - Français
import frCommon from './locales/fr/common.json';
import frGuestPortal from './locales/fr/guestPortal.json';

// Configuración de i18next
i18n
  .use(LanguageDetector) // Detecta el idioma del navegador
  .use(initReactI18next) // Integración con React
  .init({
    resources: {
      es: {
        common: esCommon,
        guestPortal: esGuestPortal,
      },
      ca: {
        common: caCommon,
        guestPortal: caGuestPortal,
      },
      en: {
        common: enCommon,
        guestPortal: enGuestPortal,
      },
      fr: {
        common: frCommon,
        guestPortal: frGuestPortal,
      },
    },
    fallbackLng: 'es', // Idioma por defecto
    defaultNS: 'common', // Namespace por defecto
    
    // Configuración de detección de idioma
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    
    interpolation: {
      escapeValue: false, // React ya escapa por defecto
    },
    
    // Debug en desarrollo
    debug: import.meta.env.DEV,
  });

export default i18n;
